import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ExamRoom from './components/ExamRoom';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/:userId/:role/:roomId" element={<ExamRoom />} />
          <Route path="/" element={
            <div className="min-h-screen bg-gray-100 flex items-center justify-center">
              <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">
                  Sistem Ujian Online
                </h1>
                <div className="space-y-4">
                  <div className="text-sm text-gray-600">
                    <p className="font-semibold mb-2 text-red-400">Format URL:</p>
                    <code className="bg-gray-100 px-2 py-1 rounded text-xs">
                      /{'{user_id}'}/{'{role}'}/{'{room_id}'}
                    </code>
                  </div>
                  <div className="text-sm text-gray-600">
                    <p className="font-semibold mb-2">Contoh:</p>
                    <ul className="space-y-1 text-xs">
                      <li>• <code>/student001/student/room-A1</code> (Peserta)</li>
                      <li>• <code>/supervisor01/supervisor/room-A1</code> (Pengawas)</li>
                    </ul>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-md">
                    <p className="text-xs text-blue-800">
                      Masukkan URL sesuai format di atas untuk mengakses ruang ujian.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;